import { ORGANIZATIONS_KEY } from '@/atoms/organizations.atom';
import FullPageLoader from '@/components/FullPageLoader';
import { buildAppUrl } from '@/core/domain';
import { getToken, removeToken } from '@/core/token';
import { analytics } from '@/lib/analytics';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function LogoutPage() {
  const { t } = useTranslation('auth');
  useEffect(() => {
    analytics.reset();
    fetch(`${import.meta.env.VITE_ENDPOINT}/logout`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }).finally(() => {
      localStorage.removeItem(ORGANIZATIONS_KEY);
      removeToken();
      window.location.href = buildAppUrl('/auth/login');
    });
  }, []);

  return <FullPageLoader title={t('logout.loading')} subtitle={t('logout.loggingOut')} />;
}
